import { FunctionName } from "../../storyV2/function/FunctionRegistry";
import { StoryNodeDisplayType } from "../../storyV2/domain/StoryNodeDisplayType";
export class FunctionNameUtil {
    static parse(node) {
        const displayType = node.options.displayType;
        switch (displayType) {
            case StoryNodeDisplayType.AMAZONSHOPPING:
                return FunctionName.amazonShopping;
            case StoryNodeDisplayType.WEEESHOPPING:
                return FunctionName.weeeShopping;
            case StoryNodeDisplayType.JDSHOPPING:
                return FunctionName.jdShopping;
            case StoryNodeDisplayType.SHOWFOODINTERFACE:
                return FunctionName.food;
            case StoryNodeDisplayType.VIDEO:
            case StoryNodeDisplayType.BASEVIDEO:
                return FunctionName.youtubeVideos;
        }
        return undefined;
    }
}
